const modal = document.querySelector(".product-modal");
const trigger = document.querySelectorAll(".openproduct");
const smtrigger = document.querySelector(".smopenproduct");
const closeButton = document.querySelector(".close-button");

    function toggleModal() {
        modal.classList.toggle("show-modal");
    }

    function windowOnClick(event) {
        if (event.target === modal) {
            toggleModal();
        }
    }

    trigger.forEach(function(e){e.addEventListener("click", toggleModal);})
    smtrigger.addEventListener("click", toggleModal);
    closeButton.addEventListener("click", toggleModal);
    window.addEventListener("click", windowOnClick);

  document.addEventListener('DOMContentLoaded', () => {
  // check if the URL contains the hashtag
  if (window.location.hash === '#show-modal') {
    // if the hashtag is present, toggle the modal
    toggleModal();
  }
});